namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_widget_float_entity_field, {

		Field_row: {
			flex: { grow: 1 },
			alignItems: 'center',
			minWidth: 0,
			overflow: 'hidden',
			background: { color: $mol_theme.card },
			border: { bottom: { width: '1px', style: 'solid', color: $mol_theme.line } },
		},

		Field_settings: {
			flex: { grow: 0, shrink: 0 },
		},

		Field_settings_list: {
			minWidth: '20rem',
			background: { color: $mol_theme.card },
		},

		Field_title: {
			flex: { grow: 1, shrink: 1, basis: '8rem' },
			minWidth: 0,
			padding: { left: $mol_gap.block, right: $mol_gap.block },
			alignItems: 'center',
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis',
		},

		Field_type_title: {
			flex: { grow: 0, shrink: 1, basis: '7rem' },
			minWidth: '5rem',
			alignItems: 'center',
			color: $mol_theme.shade,
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
		},

		Relation_summary: {
			alignItems: 'center',
			maxWidth: '9rem',
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis',
			color: $mol_theme.shade,
			padding: { left: $mol_gap.block, right: $mol_gap.block },
		},

	} )

}
